export default __webpack_public_path__ + "static/media/close-icon.cbc5141f.svg";